import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import Box from "../../../components/Box";
import { Helpers } from "../../../helpers/Helpers";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import { storeActivityIndicator, storeImageViewer } from "../../../redux/reducers/authSlice";
import toast from "react-hot-toast";
import { ContainerService } from "../../../services/ContainerService";
import { AddContainerResponse } from "../../../models/response/container/AddContainerResponse";
import { GetContainerByIdResponse } from "../../../models/response/container/GetContainerByIdResponse";

const ContainerAdd = () => {
    const navigate = useNavigate();
    const pageName = "Genel Tanımlamalar > Konteyner Tanımları"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();

    const [containerId, setContainerId] = useState<string | undefined>(undefined);

    const containerFileRef: any = useRef();
    const [containerFileB64, setContainerFileB64] = useState(Helpers.getPlaceholder());
    const [containerFile, setContainerFile] = useState<File | undefined>(undefined);
    const [name, setName] = useState<string | undefined>(undefined);
    const [code, setCode] = useState<string | undefined>(undefined);
    const [width, setWidth] = useState<string | undefined>(undefined);
    const [length, setLength] = useState<string | undefined>(undefined);
    const [height, setHeight] = useState<string | undefined>(undefined);
    const [volume, setVolume] = useState<string | undefined>(undefined);
    const [doorWidth, setDoorWidth] = useState<string | undefined>(undefined);
    const [doorHeight, setDoorHeight] = useState<string | undefined>(undefined);
    const [emptyWeight, setEmptyWeight] = useState<string | undefined>(undefined);
    const [maxLoadWeight, setMaxLoadWeight] = useState<string | undefined>(undefined);
    const [ceilingHeight, setCeilingHeight] = useState<string | undefined>(undefined);
    const [standartPalletCapacity, setStandartPalletCapacity] = useState<string | undefined>(undefined);
    const [euroPalletCapacity, setEuroPalletCapacity] = useState<string | undefined>(undefined);

    const handleFileRead = async (event: any, setFunction: React.Dispatch<React.SetStateAction<string>>) => {
        try {
            const file = event.target.files[0]
            const base64: any = await convertBase64(file)
            setFunction(base64);
        } catch (error) {
            setFunction(Helpers.getPlaceholder())
        }
    }

    const convertBase64 = (file: any) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file)
            fileReader.onload = () => {
                resolve(fileReader.result);
            }
            fileReader.onerror = (error) => {
                reject(error);
            }
        })
    }

    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, [])

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            if (id) {
                var response: GetContainerByIdResponse = await ContainerService.getContainerById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setContainerId(response.data.containerId);
                setCode(response.data.code);
                setName(response.data.name);
                setContainerFileB64(Helpers.isEmpty(response.data.image) ? Helpers.getPlaceholder() : response.data.image);
                setWidth(response.data.width?.toString());
                setLength(response.data.length?.toString());
                setHeight(response.data.height?.toString());
                setVolume(response.data.volume?.toString());
                setDoorWidth(response.data.doorWidth?.toString());
                setDoorHeight(response.data.doorHeight?.toString());
                setEmptyWeight(response.data.emptyWeight?.toString());
                setMaxLoadWeight(response.data.maxLoadWeight?.toString());
                setCeilingHeight(response.data.ceilingHeight?.toString());
                setStandartPalletCapacity(response.data.standartPalletCapacity?.toString());
                setEuroPalletCapacity(response.data.euroPalletCapacity?.toString());
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }
    const saveContainer = async () => {
        try {
            if (Helpers.isEmpty(name))
                toast.error('Ad alanını doldurunuz!')
            else {
                dispatch(storeActivityIndicator(true));

                var response: AddContainerResponse = await ContainerService.addContainer(containerId, code, name, width, length, height, volume, doorWidth, doorHeight, emptyWeight, maxLoadWeight, ceilingHeight, standartPalletCapacity, euroPalletCapacity, (containerFileB64.startsWith("http") ? containerFileB64 : undefined), containerFile);

                if (!response.isSuccess) {
                    toast.error(response.message);
                    dispatch(storeActivityIndicator(false));
                    return;
                }

                toast.success(response.message)

                dispatch(storeActivityIndicator(false));
                navigate(Helpers.getGoBackUrl())
            }
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <div>
                        <KTCard className="ebbe-card">
                            <KTCardBody>
                                <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                                <div className='row'>
                                    <div className="col-md-9">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div>
                                                    <label htmlFor="exampleFormControlInput1" className="form-label">Kod</label>
                                                    <input disabled style={{ border: '1px solid #F1F1F4' }} value={code} onChange={(e) => setCode(e.target.value)} type="text" className="form-control form-control-solid" />
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div>
                                                    <label htmlFor="exampleFormControlInput1" className="form-label required">Ad</label>
                                                    <input style={{ border: '1px solid #F1F1F4' }} value={name} onChange={(e) => setName(e.target.value)} type="text" className="form-control form-control-solid" />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row mt-5">
                                            <div className="col-md-6">
                                                <div>
                                                    <label htmlFor="exampleFormControlInput1" className="form-label">Genişlik (cm)</label>
                                                    <input style={{ border: '1px solid #F1F1F4' }} value={width} onChange={(e) => setWidth(e.target.value)} type="number" className="form-control form-control-solid" />
                                                </div>

                                                <div className="mt-5">
                                                    <label htmlFor="exampleFormControlInput1" className="form-label">Uzunluk (cm)</label>
                                                    <input style={{ border: '1px solid #F1F1F4' }} value={length} onChange={(e) => setLength(e.target.value)} type="number" className="form-control form-control-solid" />
                                                </div>

                                                <div className="mt-5">
                                                    <label htmlFor="exampleFormControlInput1" className="form-label">Yükseklik (cm)</label>
                                                    <input style={{ border: '1px solid #F1F1F4' }} value={height} onChange={(e) => setHeight(e.target.value)} type="number" className="form-control form-control-solid" />
                                                </div>

                                                <div className="mt-5">
                                                    <label htmlFor="exampleFormControlInput1" className="form-label">Hacim (m<sup>3</sup>)</label>
                                                    <input style={{ border: '1px solid #F1F1F4' }} value={volume} onChange={(e) => setVolume(e.target.value)} type="number" className="form-control form-control-solid" />
                                                </div>

                                                <div className="mt-5">
                                                    <label htmlFor="exampleFormControlInput1" className="form-label">Standart Palet Kapasitesi (1.2m x 1m)</label>
                                                    <input style={{ border: '1px solid #F1F1F4' }} value={standartPalletCapacity} onChange={(e) => setStandartPalletCapacity(e.target.value)} type="number" className="form-control form-control-solid" />
                                                </div>

                                                <div className="mt-5">
                                                    <label htmlFor="exampleFormControlInput1" className="form-label">Tavan Yükselmesi (cm)</label>
                                                    <input style={{ border: '1px solid #F1F1F4' }} value={ceilingHeight} onChange={(e) => setCeilingHeight(e.target.value)} type="number" className="form-control form-control-solid" />
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div>
                                                    <label htmlFor="exampleFormControlInput1" className="form-label">Kapı Genişliği (cm)</label>
                                                    <input style={{ border: '1px solid #F1F1F4' }} value={doorWidth} onChange={(e) => setDoorWidth(e.target.value)} type="number" className="form-control form-control-solid" />
                                                </div>

                                                <div className="mt-5">
                                                    <label htmlFor="exampleFormControlInput1" className="form-label">Kapı Yüksekliği (cm)</label>
                                                    <input style={{ border: '1px solid #F1F1F4' }} value={doorHeight} onChange={(e) => setDoorHeight(e.target.value)} type="number" className="form-control form-control-solid" />
                                                </div>

                                                <div className="mt-5">
                                                    <label htmlFor="exampleFormControlInput1" className="form-label">Boş Ağırlık (kg)</label>
                                                    <input style={{ border: '1px solid #F1F1F4' }} value={emptyWeight} onChange={(e) => setEmptyWeight(e.target.value)} type="number" className="form-control form-control-solid" />
                                                </div>

                                                <div className="mt-5">
                                                    <label htmlFor="exampleFormControlInput1" className="form-label">Max. Yük Kapasitesi (kg)</label>
                                                    <input style={{ border: '1px solid #F1F1F4' }} value={maxLoadWeight} onChange={(e) => setMaxLoadWeight(e.target.value)} type="number" className="form-control form-control-solid" />
                                                </div>

                                                <div className="mt-5">
                                                    <label htmlFor="exampleFormControlInput1" className="form-label">Euro Palet Kapasitesi (1.2m x 0.8m)</label>
                                                    <input style={{ border: '1px solid #F1F1F4' }} value={euroPalletCapacity} onChange={(e) => setEuroPalletCapacity(e.target.value)} type="number" className="form-control form-control-solid" />
                                                </div>
                                            </div>
                                        </div>

                                        <Box className="mt-10" flexDirection="row">
                                            {
                                                [
                                                    { shortName: 'DC', longName: 'DRY Container', color: '#48ff42' },
                                                    { shortName: 'HC', longName: 'High Cube', color: '#fef8a0' },
                                                    { shortName: 'OT', longName: 'Open Top', color: '#4dd7fb' },
                                                    { shortName: 'FR', longName: 'Flat Rack', color: '#ff8a83' },
                                                    { shortName: 'RF', longName: 'Reefer', color: '#e692f8' },
                                                    { shortName: 'PW', longName: 'Pallet Wide', color: '#feb254' },
                                                ].map(item =>
                                                    <Box flex={1} flexDirection='row'>
                                                        <Box borderRadius="3px" border="1px dashed black" justifyContent="center" alignItems="center" width="35px" height="25px" bg={item.color} className='font-weight-bold'>
                                                            <span style={{ fontWeight: '600' }}>{item.shortName}</span>
                                                        </Box>
                                                        <Box ml="5px" justifyContent="center">
                                                            <span style={{ fontWeight: '600' }}>{item.longName}</span>
                                                        </Box>
                                                    </Box>
                                                )
                                            }
                                        </Box>
                                    </div>

                                    <div className="col-md-3">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Konteyner Resmi</label>

                                        <div>
                                            <img onClick={() => dispatch(storeImageViewer([containerFileB64]))} style={{ width: '100%' }} className="actionIcon img img-thumbnail" src={containerFileB64} />

                                            <div className='mt-5 p-3 img img-thumbnail d-flex'>
                                                <div className='d-flex flex-grow-1'>
                                                    <input accept="image/*" ref={containerFileRef} onChange={(e) => { setContainerFile(e && e.target && e.target.files && e.target.files.length > 0 ? e.target.files[0] : undefined); handleFileRead(e, setContainerFileB64); }} type="file" className="form-control form-control-solid" />
                                                </div>

                                                {
                                                    !Helpers.isEmpty(containerFileB64) && (
                                                        <div style={{ marginLeft: 15 }} className='d-flex align-items-center'>
                                                            <i onClick={() => { setContainerFile(undefined); setContainerFileB64(Helpers.getPlaceholder()); containerFileRef.current.value = ""; }} style={{ fontSize: 18 }} className='actionIcon text-danger fa fa-trash' />
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </KTCardBody>
                        </KTCard>
                    </div>

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">

                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={saveContainer}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment>
    )
}

export default ContainerAdd;